import React from 'react';

// Styles
import { Files } from '../styles/forms';

const adaptFileEventToValue = (delegate, maxFileSize, onSizeError) => e => {
  const file = e.target.files[0];

  if (file && maxFileSize && file.size > maxFileSize) {
    e.target.value = '';
    if (onSizeError) onSizeError(file);
    return;
  }

  if (onSizeError) onSizeError(null);
  delegate(file);
};

const FileInput = ({
  input: { value: omitValue, onChange, onBlur, ...inputProps },
  meta: omitMeta,
  maxFileSize,
  onSizeError,
  ...props
}) => (
  <>
    <Files
      onChange={adaptFileEventToValue(onChange, maxFileSize, onSizeError)}
      onBlur={adaptFileEventToValue(onBlur, maxFileSize, onSizeError)}
      {...inputProps}
      {...props}
    />
  </>
);

export default FileInput;
